import { Component, input } from '@angular/core';
import { TieringCutoffHint } from '../../models/tiering-cutoff-hint.models';
import { imgPrefix } from '../../../game';

@Component({
  selector: 'app-tiering-cutoff-hint',
  templateUrl: './tiering-cutoff-hint.component.html',
  styleUrls: ['./tiering-cutoff-hint.component.scss'],
})
export class TieringCutoffHintComponent {
  hint = input.required<TieringCutoffHint>();
  showArrow = input(true);

  imgPrefix = imgPrefix;
}
